import { DocumentTempSaveRequest } from "apis/data-contracts";
import { useUpldateTempDocumentMutation } from "../mutations/useUpldateTempDocumentMutation";

export interface UpdateTempDocProps {
  documentUuid: string;
  updateRequest: DocumentTempSaveRequest;
  successCallback?: (documentUuid: string) => void;
}

const useUpdateTempDoc = () => {
  const updateTempDocumentMutation = useUpldateTempDocumentMutation();

  function updateTempDoc({
    documentUuid,
    updateRequest,
    successCallback,
  }: UpdateTempDocProps) {
    updateTempDocumentMutation.mutate(
      {
        uuid: documentUuid,
        data: updateRequest,
      },
      {
        onSuccess: () => {
          if (successCallback) successCallback(documentUuid);
        },
      },
    );
  }

  return {
    updateTempDoc,
  };
};

export default useUpdateTempDoc;
